// a mock component before the real data is loaded
// gradient moving effect

import { createUseStyles } from "react-jss"

interface InsuranceListLoadingMockProps {
  height?: string;
  width?: string;
}

const useStyles = createUseStyles({
  loadingMockItem: {
    display: 'flex',
    background: 'linear-gradient(to right, #f0f0f0 0%,#bebebe 50%, #f0f0f0 100%)',
    backgroundSize: '200% 100%',
    animation: '$movingGradient 1.5s infinite linear',
    borderRadius: '10px',
    marginBottom: '12px',
  },
  '@keyframes movingGradient': {
    '0%': { backgroundPosition: '200% 50%' },
    '100%': { backgroundPosition: '0% 50%' },
  },
});

export default function InsuranceListLoadingMock({ 
  height = "100px", 
  width = "100%" 
}: InsuranceListLoadingMockProps) {
  const classes = useStyles();

  return (
    <div className={classes.loadingMockItem} style={{ height: height, width: width }}></div>
  );
}